module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAALCAYAAABcUvyWAAAAg0lEQVQYlVXOoQoCURAF0LMPBUWwGPYvDAqyTSyKwWgy2N6PafAHxLRYrH6IxSAGwbCWt/C8MGUOw50ixihLgQ3K4D9rTPDNYYEZHji1UGGOJw74BIyxwgtHvCFgmUov6UILVzSpeJjDHXVa7jFoAW5pRtih18nerdHHFNscGpzRRfkDGScWTYQaeScAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pageL.png
// module id = 1062
// module chunks = 1